import { render, staticRenderFns } from "./Profile.Favorite.vue?vue&type=template&id=0da565c9&scoped=true"
import script from "./Profile.Favorite.vue?vue&type=script&lang=js"
export * from "./Profile.Favorite.vue?vue&type=script&lang=js"
import style0 from "./Profile.Favorite.vue?vue&type=style&index=0&id=0da565c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da565c9",
  null
  
)

export default component.exports